class MetricField extends ReportField {
    override $type: string = "irng.MetricField, irng.Data";

    isOriginalTemplate: boolean;

    metricContainer: MetricContainer;
    yAxisChartDefinition: YAxisChartDefinition;

    numberFormat: KnockoutObservable<FieldFormatEnum>;
    decimalPlaces: KnockoutObservable<number>;
    accountingStyle: KnockoutObservable<boolean>;
    backgroundColor: KnockoutObservable<string>;
    foreColor: KnockoutObservable<string>;
    thresholdValue: KnockoutObservable<number>;
    thresholdColor: KnockoutObservable<string>;
    isChecked: KnockoutObservable<boolean>;
    useFormattingRuleFromMetric: KnockoutObservable<boolean>;
    formattingRule: KnockoutObservable<number>;
    visualizationModeDefinition: VisualizationModeDefinition = new VisualizationModeDefinition();
    showSubtotalValue: KnockoutObservable<boolean>;
    showTotalValue: KnockoutObservable<boolean>;
    calculateTotals: KnockoutObservable<CalculateTotalsEnum>;
    metricFormat: MetricFormat;

    //Only in JS class to format tooltip(initial for bubble)
    //format: MetricFormat;

    /** For charts */
    tooltipFormat: TooltipFormat;

    /** For report designer */
    parentMetricField: MetricField;

    override get queryName() {
        return this.metricContainer.queryName;
    }

    override get isMetric() {
        return true;
    }

    override customDisplayName: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: MetricField) {
            return this._customDisplayName();
        },
        write: function (this: MetricField, value: string) {
            if (this.metricContainer?.metric != null && value == this.metricContainer.displayName) {
                this._customDisplayName(null);
                this._displayName = null;
            }
            else {
                this._customDisplayName(value);
            }
        },
        owner: this
    });

    override displayName: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: MetricField) {
            return this._displayName ?? (this.customDisplayName() ?? this.metricContainer.displayName);
        },
        write: function (this: MetricField, value: string) {
            if (this.metricContainer.metric && this._displayName === this.metricContainer.displayName)
                this._displayName = null;
            else
                this._displayName = value;
        },
        owner: this
    });

    override displayNameForDesigner: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: MetricField) {
            return this.customDisplayName() ?? this.fieldDisplayName ??  this.displayName();
        },
        write: function (this: MetricField, value: string) {
            this.customDisplayName(value);
        },
        owner: this
    });

    private _displayNameForExpression;
    get displayNameForExpression() {
        return this._displayNameForExpression ?? this.displayNameForDesigner();
    }
    set displayNameForExpression(value: string) {
        this._displayNameForExpression = value;
    }

    override get fieldOriginalName(): string {
        return this.metricContainer?.originalName ?? this.fieldDisplayName;
    }
    override get fieldDisplayName(): string {
        let displayName = null;
        if (this.isOriginalTemplate) {
            displayName = this.metricContainer.originalName;
        }

        return displayName ?? this.metricContainer.displayName;
    }
    override get fieldDisplayTableName(): string {
        return this.metricContainer.tableName;
    }

    constructor(data?: any, isOriginalTemplate: boolean = false) {
        super(data); //call base class constructor

        this.isOriginalTemplate = isOriginalTemplate;
        this.yAxisChartDefinition = new YAxisChartDefinition(data.yAxisChartDefinition);
        this.visualizationModeDefinition = new VisualizationModeDefinition(data.visualizationModeDefinition);
        this.metricContainer = new MetricContainer(data.metricContainer);
        this.metricFormat = new MetricFormat(data.metricFormat);

        this.numberFormat = ko.observable(data.numberFormat);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
        this.accountingStyle = ko.observable(data.accountingStyle);
        this.backgroundColor = ko.observable(data.backgroundColor);
        this.foreColor = ko.observable(data.foreColor);
        this.thresholdValue = ko.observable(data.thresholdValue);
        this.thresholdColor = ko.observable(data.thresholdColor);
        this.isChecked = ko.observable(data.isChecked ?? true);
        this.useFormattingRuleFromMetric = ko.observable(data.useFormattingRuleFromMetric ?? true);
        this.formattingRule = ko.observable(data.formattingRule);
        this.showSubtotalValue = ko.observable(data.showSubtotalValue ?? true);
        this.showTotalValue = ko.observable(data.showTotalValue ?? true);
        this.calculateTotals = ko.observable(data.calculateTotals);

        //doesn't serialize the property, avoiding circular reference
        Object.defineProperty(this, "parentMetricField", {
            value: null,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
